// extracted by mini-css-extract-plugin
export default {"tooltip":"Am21Zm","content":"mi2IN1"};